export default __webpack_public_path__ + "aef98f55f3c88066bc857c709c28d5fb.png";